export default __webpack_public_path__ + "static/media/HP-Logo.ea600826.png";